export default "__VITE_ASSET__b606824d__"